import type { FC } from "react";

import Skeleton from "@/components/global/SkeletonComponent/server/SkeletonComponent";
import { cn } from "@/utils/common/styleHelper/utils";

import SkeletonPromotionHeadingComponent from "./SkeletonPromotionHeadingComponent";

interface SkeletonPromotionCarouselComponentProps {
  isHaveHeading?: boolean;
  isShowIcon?: boolean;
  classNames?: {
    base?: string;
  };
}

const SkeletonPromotionCarouselComponent: FC<
  SkeletonPromotionCarouselComponentProps
> = ({
  isHaveHeading = false,
  isShowIcon = false,
  classNames = { base: "" },
}) => {
  const { base } = classNames;

  return (
    <div className={cn("flex w-full flex-col gap-4 md:gap-6", base)}>
      {isHaveHeading && (
        <SkeletonPromotionHeadingComponent isShowIcon={isShowIcon} />
      )}
      {/* Mobile */}
      <div className="flex w-full gap-x-4 overflow-auto no-scrollbar md:hidden">
        <Skeleton className="h-[10.667rem] min-w-[19.375rem] rounded-[10px]" />
        <Skeleton className="mr-4 h-[10.667rem] min-w-[19.375rem] rounded-[10px]" />
      </div>
      {/* Ipad Mini, Ipad Air */}
      <div className="hidden gap-x-4 overflow-auto no-scrollbar md:max-lg:flex">
        <Skeleton className="h-[10.899rem] min-w-[19.375rem] rounded-[10px]" />
        <Skeleton className="h-[10.899rem] min-w-[19.375rem] rounded-[10px]" />
        <Skeleton className="h-[10.899rem] min-w-[19.375rem] rounded-[10px]" />
        <Skeleton className="h-[10.899rem] min-w-[19.375rem] rounded-[10px]" />
      </div>
      {/* Ipad Pro */}
      <div className="hidden gap-x-4 overflow-auto no-scrollbar lg:max-xl:flex">
        <Skeleton className="h-[10.667rem] min-w-[19.375rem] rounded-[10px]" />
        <Skeleton className="h-[10.667rem] min-w-[19.375rem] rounded-[10px]" />
        <Skeleton className="h-[10.667rem] min-w-[19.375rem] rounded-[10px]" />
        <Skeleton className="h-[10.667rem] min-w-[19.375rem] rounded-[10px]" />
      </div>
      {/* Desktop ++ */}
      <div className="hidden gap-x-4 xl:flex">
        <Skeleton className="h-[13.386rem] min-w-[24.313rem] rounded-[10px]" />
        <Skeleton className="h-[13.386rem] min-w-[24.313rem] rounded-[10px]" />
        <Skeleton className="h-[13.386rem] min-w-[24.313rem] rounded-[10px]" />
      </div>
    </div>
  );
};

export default SkeletonPromotionCarouselComponent;
